const listDevices = [
  {
    model: "iPhone 6s",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone8%2C1/online-infobox.png",
  },
  {
    model: "iPhone 13",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone13%2C1/online-infobox.png",
  },
  {
    model: "iPhone 12",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone12%2C1/online-infobox.png",
  },
  {
    model: "iPhone 14",
    img: "https://statici.icloud.com/fmipmobile/deviceImages-9.0/iPhone/iPhone14%2C5/online-infobox__2x.png",
  },
];

export default listDevices;
